import type { SVGProps } from 'react';

const SvgSofaOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.314 4.392a2.8 2.8 0 0 1 1.88-.706h9.612c.69 0 1.368.246 1.88.706.514.463.82 1.109.82 1.802v2.124a2.7 2.7 0 0 1 1.923 2.586v4.805a2.7 2.7 0 0 1-1.923 2.586v1.259a.778.778 0 1 1-1.557 0V18.41H6.051v1.144a.778.778 0 1 1-1.557 0v-1.259A2.7 2.7 0 0 1 2.57 15.71v-4.805a2.7 2.7 0 0 1 1.923-2.586V6.194c0-.693.306-1.34.82-1.802m.737 3.926a2.7 2.7 0 0 1 1.922 2.586v1.143h8.054v-1.143a2.7 2.7 0 0 1 1.922-2.586V6.194a.87.87 0 0 0-.305-.644 1.26 1.26 0 0 0-.838-.307H7.193c-.328 0-.628.118-.838.307a.87.87 0 0 0-.305.644zM5.272 9.76a1.144 1.144 0 0 0-1.144 1.144v4.805a1.144 1.144 0 0 0 1.144 1.144h13.456a1.144 1.144 0 0 0 1.143-1.144v-4.805a1.144 1.144 0 1 0-2.287 0v1.441a1.26 1.26 0 0 1-1.259 1.26h-8.65a1.26 1.26 0 0 1-1.26-1.26v-1.441A1.144 1.144 0 0 0 5.273 9.76"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgSofaOutlined;
